import {INFL_W} from '../content/lawtables';
import {GROUPS} from '../content/axes';
import {DI,DM,on} from '../content/settings';
import {ISS} from '../content/states';
import {debtLimit} from './budget';
import {isv} from './opinion';
import {S} from './state';
import {since} from './version';
import {demoTick} from './demo9';
import {clamp,de,sg} from './util';


export function econTick(){
  if(on('infl')){
    const t=1.9+(S.gr-1.2)*.6+Math.max(0,debtLimit()-S.saldo)*.03*DM()+(isv('energie')-52)*.03+(isv('preise')-49)*.03+(S.shockInfl||0);
    S.infl+=(clamp(t,-1,12)-S.infl)*.08*DM();S.shockInfl=(S.shockInfl||0)*.9;
    const zt=clamp(2+1.5*(S.infl-2),0,8);S.zins+=(zt-S.zins)*.06;
    S.drate+=(S.zins-S.drate)*.015;
  }
  if(since(9)){demoTick();return}
  if(on('demo')){
    const add=[.06,.1,.14][DI()]*(1-Math.min(.8,S.demoCut||0));S.demoCost+=add;
    ['rente','pflege'].forEach((k:any)=>{if(S.issues[k])S.issues[k].sev=clamp(S.issues[k].sev+.04*DM()*(1-Math.min(.8,S.demoCut||0)),0,100)});
  }
}

export function interestV7(){return on('infl')?(S.debt*S.drate-2950*2)/100:Math.max(0,S.debt-2950)*.03}
export const inflRev:any=()=>on('infl')?(S.infl-2)*1.2:0;
export const inflPen=(g:any)=>on('infl')?Math.max(0,S.infl-2.5)*INFL_W[g]*2:0;
export function applyEff(e?:any){
  if(!e)return;
  if(e.debt)S.debt+=e.debt;
  if(e.b)S.shockB+=e.b;
  if(e.lb)S.lawB+=e.lb;
  if(e.gr)S.shockGr+=e.gr;
  if(e.al)S.lawAl+=e.al;
  if(e.infl)S.shockInfl=(S.shockInfl||0)+e.infl;
  for(const g in (e.g||{}))S.bonus[g]+=e.g[g];
  for(const k in (e.iss||{}))if(S.issues[k]){S.issues[k].sev=clamp(S.issues[k].sev+e.iss[k],0,100);if(e.iss[k]>0&&!S.issues[k].on&&S.issues[k].sev>=25){S.issues[k].on=true;S.issues[k].solved=null}}
  if(e.basis)S.basis+=e.basis;
  if(e.coal&&S.partners.length)S.coal=clamp(S.coal+e.coal,0,100);
  for(const k in (e.lob||{}))S.lob[k]=clamp(S.lob[k]+e.lob[k],0,100);
  if(e.crisis)S.crisisM=S.m;
}
export function effTags(e?:any){const o:any=[],t=(x:any,g:any)=>o.push(`<span class="tag ${g?'up':'down'}">${x}</span>`);
  if(e.debt)t(`Neue Schulden ${de(e.debt,0)} Mrd`,false);
  if(e.b)t(`Haushalt ${sg(e.b,0)} Mrd einmalig`,e.b>0);
  if(e.lb)t(`Haushalt ${sg(e.lb)} Mrd/J dauerhaft`,e.lb>0);
  if(e.gr)t(`Wachstum ${sg(e.gr,1)} Pkt`,e.gr>0);
  if(e.infl)t(`Inflation ${sg(e.infl,1)} Pkt`,e.infl<0);
  for(const g in (e.g||{}))if(Math.abs(e.g[g])>=1)t(`${GROUPS[g]} ${sg(e.g[g],0)}`,e.g[g]>0);
  for(const k in (e.iss||{}))if(Math.abs(e.iss[k])>=3)t(`${ISS[k].n} ${e.iss[k]<0?'entschärft':'verschärft'}`,e.iss[k]<0);
  return o.join('');
}
